export default "__VITE_ASSET__CsfJY0a0__"